import * as Yup from 'yup';

import { billingAddressValidation } from './BillingAddress';
import { ContactValidation } from './Contact';
import { customerValidation } from './Customer';
import { shippingAddressValidation } from './ShippingAddress';

export const csvCustomerValidationSchema = Yup.object().shape({
  ...customerValidation.fields,

  primaryContact: Yup.object().shape(ContactValidation().fields),
  defaultBillingAddress: billingAddressValidation,
  defaultShippingAddress: Yup.mixed().when('isSameShipping', {
    is: false,
    then: shippingAddressValidation,
    otherwise: Yup.mixed().nullable(),
  }),
});
